import { Injectable } from '@angular/core';
import { HttpWrapperService } from '../http/http-wrapper/http-wrapper.service';
import { Endpoints } from '../http/http-wrapper/endpoint';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentService {

  constructor(
    private http: HttpWrapperService
  ) { }

  checkFinanceDocuments(token) {
    return new Promise((resolve, reject) => {
      this.http.get(Endpoints.checkFinanceDocuments(token)).subscribe(
        (res) => {
          resolve(res)
        },
        (error) => {
          reject(error);
        }
      );
    })
  }

  uploadDocuments(payload: any) {
    return new Promise((resolve, reject) => {
      this.http.post(Endpoints.uploadDocuments, payload).subscribe(
        (res) => {
          resolve(res);
        },
        (error: HttpErrorResponse) => {
          reject(error);
        }
      );
    });
  }

}


